import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { FormItemDescription } from "../../../components/antd/form/FormItemDescription";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Location
            <CpErrorWarningArrayIcon names={[`name`, "description"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            <div>
              <div className="text-sm">Provider</div>
              <FormItemDescription>Currently only locations for a BYOK cluster can be created.</FormItemDescription>
              <div className="font-semibold">BYOK</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
